import { RouteConfig } from "vue-router";

export const REmployerCompanyDataHistory: RouteConfig = {
  path: "history",
  name: "EmployerCompanyDataHistory",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-data-history" */
      "./VEmployerCompanyDataHistory.vue"
    ),
  meta: {
    title: "Company",
    label: "data history",
    tabName: "employer_company_data_history",
    alias: "data_history",
  },
};
